import { Instruction, List, ListItem, Skeleton, Typography } from 'ui';

import { useAllDealLoads } from '../../hooks/useAllDealLoads/useAllDealLoads';
import { LoadListItem } from '../LoadListItem/LoadListItem';

const Loader = () => (
  <>
    {Array.from(Array(3)).map((_, index) => (
      <ListItem key={index}>
        <Skeleton key={index} variant="rectangular" width={300} height={30} />
      </ListItem>
    ))}
  </>
);

export const DealLoads = ({ dealId }: { dealId: number }) => {
  const { data, isFetching } = useAllDealLoads(dealId);

  if (!isFetching && !data?.data.length) {
    return <Instruction>No loads found for this deal.</Instruction>;
  }

  return (
    <div>
      <Typography variant="h6">Deal loads</Typography>
      <List disablePadding>
        {isFetching ? <Loader /> : null}

        {!isFetching && data?.data.map((load) => <LoadListItem key={load.id} load={load} />)}
      </List>
    </div>
  );
};
